import { render, staticRenderFns } from "./BankBookDetail.vue?vue&type=template&id=52b4f568&"
import script from "./BankBookDetail.vue?vue&type=script&lang=js&"
export * from "./BankBookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BankBookDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports